import * as React from 'react';

import './icon-styles.css';

export const MagnetIcon = () => {
    return (
        <svg className="icon-magnet" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 50 50">
            <g id="surface1">
                <path d="M25,0c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S29.4,0,25,0z M25,5c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S23.3,5,25,5z
                        M16,18c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h5v15.8c-2.9-0.8-6.2-4-8.6-7.6c-0.4,0-0.9,0-1.5,0c-1.5,0-2.7-0.1-3.7-0.3
                    C6.1,32,4.9,32.9,4,33.5c3.2,6.1,9.1,10.7,15.7,12.2c2.7,0.6,4.4,3.8,4.4,3.8c0.2,0.3,0.5,0.6,0.9,0.6s0.7-0.2,0.9-0.6
                    c0,0,1.6-3.2,4.4-3.8c6.6-1.4,12.5-6,15.7-12.1C45,33,43.8,32.1,42.7,31c-1,0.2-2.2,0.3-3.6,0.3c-0.6,0-1.1,0-1.5,0
                    c-2.4,3.6-5.7,6.8-8.6,7.6V23h5c0.6,0,1-0.4,1-1v-3c0-0.6-0.4-1-1-1H16z M45.6,20.3c-0.1,0-0.2,0-0.3,0.1c-5.3,1.5-9.2,7-9.3,7.3
                    c-0.2,0.3-0.2,0.7-0.1,1s0.5,0.5,0.8,0.6c0,0,1.1,0.1,2.4,0.1c1.9,0,3.3-0.2,4.3-0.5c2.4,2.8,5.2,3.9,5.3,4c0.1,0,0.2,0.1,0.3,0.1
                    c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.4-0.5,0.4-0.8c0-4.5-1.2-8.2-3.7-11.1C46.1,20.4,45.8,20.3,45.6,20.3z M4.7,20.4
                    c-0.2,0-0.5,0.1-0.7,0.3C0.6,23.6,0,31.4,0,31.7c0,0.4,0.1,0.7,0.4,0.9c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3-0.1,0.4-0.1
                    c0.1-0.1,2.9-1.4,5.2-3.9c1,0.3,2.5,0.5,4.3,0.5c1.3,0,2.3-0.1,2.4-0.1c0.4,0,0.7-0.2,0.8-0.6c0.2-0.3,0.1-0.7-0.1-1
                    c-0.2-0.2-3.8-5.7-9.2-7.2C4.8,20.4,4.7,20.4,4.7,20.4z"/>
            </g>
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-magnet.tsx